import { createRouter, createWebHistory } from 'vue-router'
import { usarSesion } from '@/stores/guion'
import { token } from '@/api/cliente'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/entrar', name: 'entrar', component: () => import('@/views/Entrar.vue'), meta: { publica: true } },
    { path: '/', name: 'tenants', component: () => import('@/views/Tenants.vue') },
    { path: '/plataforma', name: 'plataforma', component: () => import('@/views/Plataforma.vue') },
    { path: '/usuarios', name: 'usuarios', component: () => import('@/views/Usuarios.vue') },
    {
      path: '/tenants/:id',
      component: () => import('@/views/Guion.vue'),
      props: true,
      children: [
        { path: '', name: 'pasos', component: () => import('@/views/Pasos.vue'), props: true },
        { path: 'grafo', name: 'grafo', component: () => import('@/views/Grafo.vue'), props: true },
        { path: 'plantillas', name: 'plantillas', component: () => import('@/views/Plantillas.vue'), props: true },
        { path: 'versiones', name: 'versiones', component: () => import('@/views/Versiones.vue'), props: true },
        { path: 'operacion', name: 'operacion', component: () => import('@/views/Operacion.vue'), props: true },
        { path: 'inteligencia', name: 'inteligencia', component: () => import('@/views/Inteligencia.vue'), props: true },
        { path: 'evaluaciones', name: 'evaluaciones', component: () => import('@/views/Evaluaciones.vue'), props: true },
      ],
    },
  ],
})

// Guardia de sesion. Se recupera del token guardado en vez de exigir entrar en
// cada recarga: quien edita un guion recarga la pagina a menudo.
router.beforeEach(async (a) => {
  if (a.meta.publica) return true

  const sesion = usarSesion()
  if (sesion.autenticado) return true
  if (!token.leer()) return { name: 'entrar', query: { volver: a.fullPath } }

  const ok = await sesion.recuperar()
  return ok ? true : { name: 'entrar', query: { volver: a.fullPath } }
})
